import React, { useState, useEffect } from 'react';
import SearchBar from '../SeachBar';
import { fetchModel, fetchModelAndAssets } from '../../utils/models/fetchModel';
import { fetchCurrThumbnail } from '../../utils/models/fetchModelAssets';
import { exportToExcel } from '../../utils/exports/excel_export';
import DateRangePicker from './DateRangePicker';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const CallTimes = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [models, setModels] = useState([]);
  const [thumbnails, setThumbnails] = useState([]);
  const [selectedStart, setSelectedStart] = useState(null);
  const [selectedEnd, setSelectedEnd] = useState(null);

  const handleDateChange = (start, end) => {
    setSelectedStart(start);
    setSelectedEnd(end);
    console.log('Selected range:', start, end);
    // You can now filter your data based on selectedStart and selectedEnd
  };

  //for testing, no real booking and call times in the backend yet
  const modelTestIds = ["54058ade2cdc5b29e6b908a6", "06091342-cbe4-4ed5-b140-2c41a8373c3f"];


  useEffect(() => {
    const fetchModelAndThumb = async () => {
      const model1 = await fetchModel(modelTestIds[0], setError);
      const model2 = await fetchModel(modelTestIds[1], setError);
      setModels([model1, model2]);

      const model1Thumb = await fetchCurrThumbnail(model1);
      const model2Thumb = await fetchCurrThumbnail(model2);

      setThumbnails([model1Thumb, model2Thumb]);
    }

    setLoading(true);
    fetchModelAndThumb();
    setLoading(false);
  }, []);

  const todayStr = new Date().toLocaleDateString('de-DE'); // "14.05.2025"

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (models.length == 0) return <div>No model data available.</div>;

  console.log("thumbnails", thumbnails);


  return (
    <div className="pool-list">
      <h1 className="title">Call Times</h1>

      <div className='datepicker-and-button'>
        <DateRangePicker onDateChange={handleDateChange} />
        <button className="button" style={{ height: "70%" }} onClick={() => { exportToExcel(models, thumbnails) }}>
          Export to Excel
        </button>
      </div>

      <table className="table" id="calltimes-table">
        <thead>
          <tr className="table-header">
            <th className="header-cell"></th>
            <th className="header-cell">Name</th>
            <th className="header-cell">Date</th>
            <th className="header-cell">Calltime</th>
            <th className="header-cell">Agency / Booker</th>
            <th className="header-cell">Location</th>
            <th className="header-cell">Studio</th>
            <th className="header-cell">Client</th>
            <th className="header-cell">Production</th>
          </tr>
        </thead>
        {models.map((model, index) => (
          <tbody key={index}>
            <tr
              className="table-row"
            >
              <th className="table-cell"><div className="image"><img src={thumbnails[index].file} style={{ height: '60px', width: 'auto' }} alt={`${model.firstName} ${model.lastName}`} /></div></th>
              <th className="table-cell">{model.firstName}</th>
              <th className="table-cell">{todayStr}</th>
              <th className="table-cell">8:00</th>
              <th className="table-cell">{model.agencies[0] || "No Agency"}</th>
              <th className="table-cell">Orendt Studios ALTONA,<br />Behringstraße 28a,<br />22765 Hamburg</th>
              <th className="table-cell">Orendt Studio Altona</th>
              <th className="table-cell">s.Oliver Bernd Freier<br />GmbH & Co. KG</th>
              <th className="table-cell">20/25 S.Oliver PR Shooting</th>
            </tr>
          </tbody>
        ))}
      </table>
    </div>
  );
};

export default CallTimes;
